module.exports = __webpack_public_path__ + "media/images/registrations/info_version/info-mobile-02-46ffc0e01417a62f44cee3429e724951.png";